var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-graph" }, [
      _c("div", { staticClass: "title" }, [
        _c("span", [_vm._v("Desempenho da carteira")])
      ]),
      _c("div", { staticClass: "indices" }, [
        _c("div", { staticClass: "indice" }, [
          _c("div", { staticClass: "title-indice" }, [
            _c("span", [_vm._v("CDI")])
          ])
        ]),
        _c("div", { staticClass: "indice" }, [
          _c("div", { staticClass: "title-indice" }, [
            _c("span", [_vm._v("IPCA")])
          ])
        ]),
        _c("div", { staticClass: "indice" }, [
          _c("div", { staticClass: "title-indice" }, [
            _c("span", [_vm._v("DÓLAR")])
          ])
        ]),
        _c("div", { staticClass: "indice" }, [
          _c("div", { staticClass: "title-indice" }, [
            _c("span", [_vm._v("IBOVESPA")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }